export const paymentGateway = (client, card) => {
    let _client = client
    let _card = card

    return {
        createToken: () => {
            return _client.createToken(_card)
        }
    }
}